import { MongoObservable } from 'meteor-rxjs';
import { EmploymentUserLog } from '../models/employmentUserLog';

export const EmploymentUserLogs =
  new MongoObservable.Collection<EmploymentUserLog>('employmentUserLogs');

if (Meteor.isServer) {
  EmploymentUserLogs.rawCollection().createIndex({ type: 1 });
  EmploymentUserLogs.rawCollection().createIndex({ timestamp: 1 });
  EmploymentUserLogs.rawCollection().createIndex({ inviteeId: 1 });
  EmploymentUserLogs.rawCollection().createIndex({ userId: 1 });
}
